import React from 'react'
import uuidv4 from 'uuid/v4'

import Module from '~/components/Module'
import SVG from '~/components/SVG'
import hostIcon from '~/assets/icon-host.svg'

import UserItem from './UserItem'
import styles from './index.css'

const Organizers = ({ organizations }) =>
  organizations && organizations.length ? (
    <Module
      headerIcon={<SVG src={hostIcon} width={13} height={15} />}
      headerText="主办方"
      className={styles.orgnizer}
      contentClassName={styles.orgnizerList}
    >
      {organizations.map(item => (
        <UserItem key={`org_${uuidv4()}`} {...item} />
      ))}
    </Module>
  ) : null

export default Organizers



// WEBPACK FOOTER //
// ./src/modules/Organizers/index.js